import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router";
import { fetchEventData } from "../../../features/shared-event/redux/actions";
import { getEventData } from "../../../features/shared-event/redux/selectors";
import { setRegistrationHash } from "../utils/eventsStorageUtils";

export const SharedEvent = () => {
  const dispatch = useDispatch();
  const { hash } = useParams();
  const eventData = useSelector(getEventData);

  const isEventExist = Boolean(eventData);
  const isNominated = Boolean(eventData?.is_nominated);
  const isOnlineEvent = Boolean(eventData?.live_links);

  useEffect(() => {
    setRegistrationHash(hash);
    dispatch(fetchEventData(hash));
  }, []);

  if (isEventExist && isNominated) {
    return <Redirect to={`/share/${hash}/nomination`} />;
  }

  if (isEventExist && !isNominated && !isOnlineEvent) {
    return <Redirect to={`/share/${hash}/event`} />;
  }

  if (isEventExist && !isNominated && isOnlineEvent) {
    return <Redirect to={`/share/${hash}/event`} />;
  }

  return <div />;
};
